var base = require('settings/preferences/default');
Vue.component('spark-preferences-default', {
    mixins: [base]
});
